import { Stack, Typography } from '@mui/material';
import { IncludeSlideCheckbox } from './IncludeSlideCheckbox';
import { IncludedSlidesPresets } from './IncludedSlidesPresets';

type IncludedSlidesFormProps = {
  hasSalesAttribution: boolean;
  hasCampaignAnalytics: boolean;
};

export const IncludedSlidesForm = (props: IncludedSlidesFormProps) => (
  <Stack direction="column" spacing={2}>
    <Typography fontWeight="bold">Presets</Typography>
    <IncludedSlidesPresets />
    <Typography fontWeight="bold">Overview</Typography>
    <IncludeSlideCheckbox name="overall.overview" label="Overview" />
    <IncludeSlideCheckbox
      name="overall.executiveSummary"
      label="Executive Summary"
    />
    <Typography fontWeight="bold">Foot Traffic</Typography>
    <IncludeSlideCheckbox name="footTraffic.titleSlide" label="Title Slide" />
    <IncludeSlideCheckbox
      name="footTraffic.overallResults"
      label="Overall Results"
    />
    <IncludeSlideCheckbox
      name="footTraffic.optimizationIndex"
      label="Optimization Index"
    />
    <IncludeSlideCheckbox name="footTraffic.dimensions" label="Dimensions" />
    {props.hasSalesAttribution ? (
      <>
        <Typography fontWeight="bold">Sales Attribution</Typography>
        <IncludeSlideCheckbox
          name="salesAttribution.titleSlide"
          label="Title Slide"
        />
        <IncludeSlideCheckbox name="salesAttribution.summary" label="Summary" />
        <IncludeSlideCheckbox
          name="salesAttribution.contributionMetrics"
          label="Contribution Metrics"
        />
        <IncludeSlideCheckbox
          name="salesAttribution.summaryTable"
          label="Summary Table"
        />
        <IncludeSlideCheckbox
          name="salesAttribution.dimensions"
          label="Dimensions"
        />
      </>
    ) : null}
    {props.hasCampaignAnalytics ? (
      <>
        <Typography fontWeight="bold">Campaign Analytics</Typography>
        <IncludeSlideCheckbox
          name="campaignAnalytics.titleSlide"
          label="Title Slide"
        />
        <IncludeSlideCheckbox
          name="campaignAnalytics.audienceProfile"
          label="Audience Profile"
        />
        <IncludeSlideCheckbox
          name="campaignAnalytics.demographicProfile"
          label="Demographic Profile"
        />
        <IncludeSlideCheckbox
          name="campaignAnalytics.stateAndDmaVisits"
          label="State and DMA Visits"
        />
        <IncludeSlideCheckbox
          name="campaignAnalytics.brandLocationVisits"
          label="Brand Location Visits"
        />
        <IncludeSlideCheckbox
          name="campaignAnalytics.proximityToHome"
          label="Proximity To Home"
        />
        <IncludeSlideCheckbox
          name="campaignAnalytics.timeToFirstVisitByDay"
          label="Time To First Visit By Day"
        />
        <IncludeSlideCheckbox
          name="campaignAnalytics.visitsByHourOfDay"
          label="Visits By Hour Of Day"
        />
        <IncludeSlideCheckbox
          name="campaignAnalytics.visitsByDayOfWeek"
          label="Visits By Day Of Week"
        />
        <IncludeSlideCheckbox
          name="campaignAnalytics.footTrafficOverlap"
          label="Foot Traffic Overlap"
        />
      </>
    ) : null}
    <Typography fontWeight="bold">Appendix</Typography>
    <IncludeSlideCheckbox name="appendix" label="Appendix" />
  </Stack>
);
